import type { BuildProductSchemaInput } from "./buildProductGroupSchema";
import type {
  StructuredDataInputMedia,
  SchemaEntity,
  JsonLdDocument,
} from "./types";
import { buildProductSchema } from "./buildProductGroupSchema";
import { buildVideoSchema } from "./buildVideoSchema";
import { buildJsonLdDocument } from "./buildJsonLdDocument";

export function buildStructuredDataDocument(
  input: BuildProductSchemaInput,
  media?: StructuredDataInputMedia | null
): JsonLdDocument {
  const productEntity = buildProductSchema(input);
  const entities: SchemaEntity[] = media?.catwalkUrl
    ? [
        productEntity,
        buildVideoSchema({
          ...media,
          name: media.name ?? input.product.name,
          description: media.description ?? input.productDescription,
          images: media.images ?? input.product.images,
        }),
      ]
    : [productEntity];
  return buildJsonLdDocument(entities);
}
